import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export function EmailModal({ open, onOpenChange, form, onFormChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-[#6A7359]">Email Quote</DialogTitle>
          <DialogDescription>Send the quote to an email address.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-3">
          <Input 
            placeholder="Your Name *" 
            value={form.name} 
            onChange={(e) => onFormChange("name", e.target.value)} 
            data-testid="email-name" 
          />
          <Input 
            placeholder="Email Address *" 
            type="email" 
            value={form.email} 
            onChange={(e) => onFormChange("email", e.target.value)} 
            data-testid="email-to" 
          />
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
              Cancel
            </Button>
            <Button 
              onClick={onSubmit} 
              className="flex-1 bg-[#6A7359] hover:bg-[#565E48]" 
              data-testid="send-email-btn"
            >
              Send Quote
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
